<template>
    <div
        class="col col-auto me-4 mb-4"
        v-if="name || email || phone || fax">
        <div class="text-left">
            <h4 class="h5">{{ title }}</h4>
        </div>
        <div v-if="name"><span class="h5"> Name:</span> {{ name }}</div>
        <div v-if="phone"><span class="h5">Phone:</span> {{ phone }}</div>
        <div v-if="email"><span class="h5">Email:</span> {{ email }}</div>
        <div v-if="fax"><span class="h5">Fax:</span> {{ fax }}</div>
    </div>
</template>
<script setup lang="ts">
const props = defineProps({
    title: {
        type: String,
        default: null,
    },
    name: {
        type: String,
        default: null,
    },
    email: {
        type: String,
        default: null,
    },
    phone: {
        type: String,
        default: null,
    },
    fax: {
        type: String,
        default: null,
    },
});
</script>
